import { render, staticRenderFns } from "./QuestionSuccess.vue?vue&type=template&id=382bb7ca&scoped=true&"
import script from "./QuestionSuccess.vue?vue&type=script&lang=js&"
export * from "./QuestionSuccess.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSuccess.vue?vue&type=style&index=0&id=382bb7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bb7ca",
  null
  
)

export default component.exports